export const getCategoryServiceIds = (category) => category?.services?.map((s) => s.id) ?? [];

export const getCategorySelectionState = (category, serviceIds) => {
  const ids = getCategoryServiceIds(category);
  if (ids.length === 0) return 'none';

  const selectedCount = ids.filter((id) => serviceIds.includes(id)).length;
  if (selectedCount === 0) return 'none';
  if (selectedCount === ids.length) return 'all';
  return 'partial';
};

export const isCategoryIndeterminate = (category, serviceIds) => getCategorySelectionState(category, serviceIds) === 'partial';

export const isCategoryFullySelected = (category, serviceIds) => getCategorySelectionState(category, serviceIds) === 'all';

export const toggleCategorySelection = (category, serviceIds) => {
  const ids = getCategoryServiceIds(category);
  if (ids.length === 0) return serviceIds;

  if (getCategorySelectionState(category, serviceIds) === 'all') {
    return serviceIds.filter((id) => !ids.includes(id));
  }

  return [...new Set([...serviceIds, ...ids])];
};

export const toggleServiceId = (serviceId, serviceIds) => (serviceIds.includes(serviceId) ? serviceIds.filter((id) => id !== serviceId) : [...serviceIds, serviceId]);

export const hasCategoryServices = (category) => (category?.services?.length ?? 0) > 0;
